// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination3_pagination__KZkXe","iconButton":"Pagination3_iconButton__uTimj","pageButton":"Pagination3_pageButton__rVPQV","active":"Pagination3_active__HuJI7"};